<template>
  <div class="debt-items">
    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>
    <KTCodePreview v-bind:title="' '">
      <template v-slot:toolbar>
        <div class="row">
          <div>
            <b-dropdown size="sm" id="dropdown-1" right>
              <template slot="button-content">
                <i style="font-size: 1rem" class="fas fa-cog"></i>
                <span class="font-weight-bolder">Thao tác</span>
              </template>
              <b-dropdown-item @click="showModalExcel">
                <span>
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Xuất Excel</span
                >
              </b-dropdown-item>
              <b-dropdown-item
                :to="{
                  name: 'import-debt',
                  params: {
                    mode: 'items',
                  },
                }"
                v-if="isShow(['TRANSACTION_IMPORT_EXCEL'])"
              >
                <span style="color: black">
                  <i style="font-size: 1rem" class="far fa-file-excel"></i>
                  &nbsp; Nhập từ Excel</span
                >
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </template>
      <template v-slot:preview>
        <b-row class="mb-5">
          <b-col>
            <b-form>
              <Autosuggest
                :model="filters.searchStock"
                :suggestions="filteredOptions"
                placeholder="cửa hàng"
                :limit="10"
                @select="onStoreSelected"
                @change="onStoreInputChange"
                :disabled="isStoreDisabled"
              />
            </b-form>
          </b-col>
          <b-col>
            <div class="date-style">
              <b-input-group>
                <date-picker
                  placeholder="Từ"
                  class="form-control form-control-sm"
                  :config="dpConfigs"
                  v-model="filters.fromDate"
                ></date-picker>
              </b-input-group>
              <span class="ml-1 mr-1"></span>
              <b-input-group>
                <date-picker
                  placeholder="Đến"
                  class="form-control form-control-sm"
                  :config="dpConfigs"
                  v-model="filters.toDate"
                ></date-picker>
              </b-input-group>
            </div>
          </b-col>
          <b-col>
            <b-form>
              <b-form-select
                v-model="filters.contactId"
                :options="installmentOptions"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form>
          </b-col>
          <b-col>
            <b-input
              placeholder="Mã HĐ"
              v-model.trim="filters.contractCode"
              size="sm"
            />
          </b-col>
          <b-col>
            <b-input
              placeholder="Chứng từ"
              v-model.trim="filters.docId"
              size="sm"
            />
          </b-col>
        </b-row>
        <b-row class="mb-5">
          <b-col>
            <b-form>
              <b-input
                placeholder="Tìm chính xác SĐT KH"
                v-model.trim="filters.customerMobile"
                size="sm"
              />
            </b-form>
          </b-col>
          <b-col>
            <b-form>
              <b-form-select
                v-model="filters.isFullPaid"
                :options="paidStatusOptions"
                size="sm"
                class="select-style"
              ></b-form-select>
            </b-form>
          </b-col>
          <b-col>
            <b-button
              style="font-weight: 600; width: 70px"
              variant="primary"
              size="sm"
              @click="onFilter()"
            >
              Lọc</b-button
            >
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>

        <!-- LIST DATA -->
        <b-row>
          <b-col md="12" lg="12" sm="12">
            <b-table-simple
              bordered
              hover
              class="tbody-hover"
              v-if="!isLoading"
            >
              <b-thead>
                <b-tr>
                  <b-th class="text-center tdDate">Ngày</b-th>
                  <b-th class="text-center tdStore">Cửa hàng</b-th>
                  <b-th class="text-center tdCustomer">Khách hàng</b-th>
                  <b-th class="text-center tdProductName">Dịch vụ trả góp</b-th>
                  <b-th class="text-center tdProductPrice">Mã hợp đồng</b-th>
                  <b-th class="text-center tdProductPrice">Tiền trả góp</b-th>
                  <b-th class="text-center tdTotalPayment">Đã thanh toán</b-th>
                  <b-th class="text-center tdTotalPayment">Còn lại</b-th>
                  <b-th class="text-center tdTotalAmount"
                    >Tổng tiền hoá đơn</b-th
                  >
                  <b-th class="text-center"></b-th>
                </b-tr>
              </b-thead>
              <b-tbody v-for="bill in tableData.dataset" :key="bill.id">
                <b-tr v-for="(item, index) in bill.payments" :key="index">
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="tdDate"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                  >
                    {{ formatDate(bill.createdAt) }}
                    <div>
                      <router-link
                        :to="{
                          path: '/bills/update-bill',
                          query: { id: bill.billNumber },
                        }"
                        target="_blank"
                        >{{ bill.billNumber }}
                      </router-link>
                    </div>
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-left tdStore"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                  >
                    {{ bill.storeName }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-left tdCenter tdCustomer"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                  >
                    <b> {{ bill.customerName }}</b>
                    <p>{{ bill.customerMobile }}</p>
                  </b-td>
                  <b-td class="text-left tdProductName">
                    <b> {{ item.paymentName }}</b>
                  </b-td>
                  <b-td class="text-right tdProductPrice">
                    {{ item.paymentCode }}
                  </b-td>
                  <b-td class="text-right tdProductPrice">
                    {{ convertPrice(item.paymentAmount) }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.sumAmountTransactions) }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.sumRemainTransaction) }}
                  </b-td>
                  <b-td
                    :rowspan="bill.payments.length + 1"
                    class="text-right tdCenter"
                    v-show="isFirstPaymentRow(bill.payments, item)"
                    style="width: 10%; color: #3c763d; font-weight: 700"
                  >
                    {{ convertPrice(bill.totalAmount) }}
                  </b-td>
                  <b-td class="text-center" style="width: 5%">
                    <b-dropdown
                      size="sm"
                      id="dropdown-left"
                      right
                      no-caret
                      v-if="bill.sumRemainTransaction > 0"
                    >
                      <template slot="button-content">
                        <i
                          style="font-size: 1rem; padding-right: 0px"
                          class="flaticon2-settings"
                        ></i>
                      </template>
                      <b-dropdown-item o-caret @click="editModalPayment(bill)">
                        <span style="color: #3f4254; font-size: 12px">
                          <i class="flaticon2-pen" style="font-size: 1rem"></i>
                          &nbsp; Chỉnh sửa
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item o-caret @click="payByCash(bill, item)">
                        <span style="color: #3f4254; font-size: 12px">
                          <i
                            style="font-size: 1rem"
                            class="far fa-money-bill-alt"
                          ></i>
                          &nbsp; Thanh toán bằng tiền mặt
                        </span>
                      </b-dropdown-item>
                      <b-dropdown-item>
                        <router-link :to="getBankPaymentRoute(bill, item)">
                          <span style="color: #3f4254; font-size: 12px">
                            <i
                              style="font-size: 1rem"
                              class="fas fa-money-check-alt"
                            ></i>
                            &nbsp; Thanh toán bằng CK ngân hàng
                          </span>
                        </router-link>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-td>
                </b-tr>
              </b-tbody>
              <b-tfoot>
                <tr>
                  <td colspan="5" class="text-right">
                    <b>Tổng</b>
                  </td>
                  <td class="text-right">
                    <b> {{ calculateTotal('sumAmountPayments') }}</b>
                  </td>
                  <td class="text-right">
                    <b> {{ calculateTotal('sumAmountTransactions') }}</b>
                  </td>
                  <td class="text-right">
                    <b>
                      {{ calculateTotal('sumRemainTransaction') }}
                    </b>
                  </td>
                  <td class="text-right">
                    <b>
                      {{ calculateTotal('totalAmount') }}
                    </b>
                  </td>
                  <td></td>
                </tr>
              </b-tfoot>
            </b-table-simple>
            <vcl-table
              v-if="isLoading"
              :speed="5"
              :animate="true"
              :columns="11"
            />
          </b-col>
        </b-row>

        <!-- PAGINATION -->
        <b-row>
          <b-col lg="3" md="3" sm="12">
            <p class="mt-3 text-dark" style="font-weight: 500">
              Tổng số:
              {{ tableData.total }}
            </p>
          </b-col>
          <b-col lg="9" md="9" sm="12">
            <b-pagination-nav
              class="custom-pagination"
              v-show="tableData.pages >= 2"
              :link-gen="generatePaginationLink"
              :number-of-pages="tableData.pages || 1"
              use-router
              @change="handlePageChange"
              align="right"
              first-class="page-item-first btn btn-icon btn-sm m-1"
              prev-class="page-item-prev btn btn-icon btn-sm m-1"
              next-class="page-item-next btn btn-icon btn-sm m-1 "
              last-class="page-item-last btn btn-icon btn-sm m-1 "
              page-class="btn btn-icon btn-sm border-0 m-1"
            >
              <template v-slot:first-text>
                <span>
                  <i class="ki ki-bold-double-arrow-back icon-xs"></i>
                </span>
              </template>

              <template v-slot:prev-text>
                <i class="ki ki-bold-arrow-back icon-xs"></i>
              </template>

              <template v-slot:next-text>
                <i class="ki ki-bold-arrow-next icon-xs"></i>
              </template>

              <template v-slot:last-text>
                <span class="text-info">
                  <i class="ki ki-bold-double-arrow-next icon-xs"></i>
                </span>
              </template>
            </b-pagination-nav>
          </b-col>
        </b-row>
      </template>
    </KTCodePreview>
    <DebtEditModal
      :item="selectedBill"
      :mode="modalMode"
      v-on:refresh="fetchData"
    />
    <template>
      <DebtExcel :param="filters" :mode="modalMode" />
    </template>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import moment from 'moment';
import _ from 'lodash';
import Loader from '@/view/content/Loader.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import { cmdUrl } from '@/utils/apiUrl';
import { getToastInstance } from '@/utils/toastHelper';
import { handleError } from '@/utils/common';
import { mapGetters } from 'vuex';
import { checkPermissions } from '@/utils/saveDataToLocal';
import { convertPrice } from '@/utils/common';
import DebtEditModal from '@/view/components/debt/DebtEditModal.vue';
import { getSubtractDate, getAddDate, formatDate } from '@/utils/date';
import { DP_CONFIG } from '@/utils/date';
import Autosuggest from '@/view/base/auto-sugguest/AutoSuggest.vue';
import DebtExcel from '../../components/debt/DebtExcel.vue';
import {
  CONTACT_TYPE,
  TRANSACTION_TYPE,
  TRANSACTION_RECONCILIATION_DOC_TYPE,
} from '@/utils/enum';

// Constants
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_DATE_RANGE = 7;
const MODAL_MODE = 'items';

export default {
  name: 'DebtItems',
  components: {
    KTCodePreview,
    Loader,
    VclTable,
    Autosuggest,
    DebtEditModal,
    DebtExcel,
  },

  data() {
    return {
      title: 'Công nợ trả góp hóa đơn theo ngày',

      // Filter state
      filters: {
        searchStock: '',
        storeId: null,
        fromDate: getSubtractDate(DEFAULT_DATE_RANGE),
        toDate: getAddDate(),
        contactId: null,
        contractCode: '',
        docId: '',
        customerMobile: '',
        isFullPaid: null,
      },

      // Pagination state
      pagination: {
        page: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },

      // Data state
      tableData: {
        dataset: [],
        total: 0,
        pages: 1,
      },

      // UI state
      isLoading: false,
      isStoreDisabled: false,

      // Options
      installmentOptions: [{ value: null, text: 'Tất cả dịch vụ trả góp' }],
      paidStatusOptions: [
        { value: null, text: 'Tất cả trạng thái' },
        { value: 'true', text: 'Đã thanh toán hết' },
        { value: 'false', text: 'Còn nợ' },
      ],
      storeOptions: [],
      filteredOptions: [],

      // Modal state
      selectedBill: { billNumber: null },
      modalMode: MODAL_MODE,

      // Date picker configuration
      dpConfigs: DP_CONFIG.date,
    };
  },

  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),

    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },

    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },

    currentFilters() {
      return {
        ...this.filters,
        ...this.pagination,
        fromDate: this.formatDateForApi(this.filters.fromDate),
        toDate: this.formatDateForApi(this.filters.toDate),
      };
    },
  },

  watch: {
    '$route.query': {
      handler() {
        this.initializeFromQuery();
        this.fetchData();
      },
      immediate: true,
      deep: true,
    },
  },

  created() {
    this.setupBreadcrumb();
    this.fetchStoresByUser();
    this.fetchInstallments();
  },

  mounted() {
    this.setupEventListeners();
  },

  beforeDestroy() {
    this.cleanupEventListeners();
  },

  methods: {
    ...getToastInstance(),

    initializeFromQuery() {
      const query = this.$route.query;
      if (_.isEmpty(query)) return;

      this.filters = {
        ...this.filters,
        storeId: query.storeId ? query.storeId : null,
        fromDate: query.fromDate || this.filters.fromDate,
        toDate: query.toDate || this.filters.toDate,
        contactId: query.contactId ? Number(query.contactId) : null,
        contractCode: query.contractCode || null,
        docId: query.docId || null,
        customerMobile: query.customerMobile || null,
        isFullPaid: query.isFullPaid || null,
      };

      this.pagination = {
        page: Number(query.page) || 1,
        pageSize: Number(query.pageSize) || DEFAULT_PAGE_SIZE,
      };
    },

    setupBreadcrumb() {
      this.$store.dispatch(SET_BREADCRUMB, [
        { title: 'Kế toán', route: 'accountant' },
        { title: 'Công nợ' },
        { title: this.title },
      ]);
    },

    setupEventListeners() {
      window.addEventListener('keyup', this.handleKeyPress);
    },

    cleanupEventListeners() {
      window.removeEventListener('keyup', this.handleKeyPress);
    },

    // Event handlers
    handleKeyPress(event) {
      if (event.key === 'Enter') {
        this.onFilter();
      }
    },

    async onFilter() {
      try {
        this.pagination.page = 1;
        this.updateUrl();
      } catch (error) {
        handleError(error);
      }
    },

    async handlePageChange(page) {
      this.pagination.page = page;
    },

    // Store handling
    onStoreSelected(option) {
      this.filters.searchStock = option.item.name;
      this.filters.storeId = option.item.id;
    },

    onStoreInputChange(text) {
      this.filters.searchStock = text || '';

      const filtered = this.storeOptions
        .filter(
          (store) =>
            store.name.toLowerCase().includes(text.toLowerCase()) ||
            store.shortName?.toLowerCase().includes(text.toLowerCase()),
        )
        .slice(0, 10);

      this.filteredOptions = filtered;
    },

    // API methods
    async fetchData() {
      if (this.isLoading) return;

      this.isLoading = true;
      try {
        const params = this.buildApiParams();
        const response = await ApiService.query(cmdUrl.DebtUrl.installments, {
          params,
        });

        this.tableData = response.data.data;
      } catch (error) {
        handleError(error);
        this.tableData = { dataset: [], total: 0, pages: 1 };
      } finally {
        this.isLoading = false;
      }
    },

    async fetchInstallments() {
      try {
        const params = { page: 1, pageSize: 1000 };
        const response = await ApiService.query('/installments', { params });

        const installments = response.data.data.result || [];
        this.installmentOptions = [
          { value: null, text: 'Tất cả dịch vụ trả góp' },
          ...installments.map((item) => ({
            value: item.id,
            text: item.name,
          })),
        ];
      } catch (error) {
        handleError(error);
      }
    },

    async fetchStoresByUser() {
      try {
        const response = await ApiService.get('stores/get-by-user');

        if (response.data.status !== 1) {
          throw new Error('Không thể tải danh sách cửa hàng');
        }

        const stores = response.data.data.stores || [];
        this.setupStoreOptions(stores);
      } catch (error) {
        handleError(error);
      }
    },

    setupStoreOptions(stores) {
      if (stores.length === 1) {
        const store = stores[0];
        this.filters.searchStock = store.name;
        this.filters.storeId = store.id;
        this.isStoreDisabled = true;
        this.storeOptions = [store];
        this.filteredOptions = [store];
      } else {
        const allStoresOption = {
          id: null,
          name: 'Tất cả cửa hàng',
          shortName: 'Tat ca cua hang',
        };

        this.storeOptions = [allStoresOption, ...stores];
        this.filteredOptions = [...this.storeOptions];
        this.filters.searchStock = allStoresOption.name;
        this.filters.storeId = allStoresOption.id;
      }
    },

    // Utility methods
    buildApiParams() {
      return {
        page: this.pagination.page,
        pageSize: this.pagination.pageSize,
        storeId: this.filters.storeId,
        contactId: this.filters.contactId,
        fromDate: this.formatDateForApi(this.filters.fromDate),
        toDate: this.formatDateForApi(this.filters.toDate),
        contractCode: this.filters.contractCode?.trim() || null,
        docId: this.filters.docId?.trim() || null,
        customerMobile: this.filters.customerMobile?.trim() || null,
        isFullPaid: this.filters.isFullPaid,
        type: this.$route.params.mode,
      };
    },

    formatDateForApi(date) {
      if (!date) return null;
      return moment(date, 'DD/MM/YYYY').format('DD/MM/YYYY');
    },

    updateUrl() {
      const query = _.omitBy(
        {
          ...this.currentFilters,
          page: this.pagination.page,
        },
        _.isNil,
      );

      this.$router.push({
        path: '/accounting/debts/items',
        query: query,
      });
    },

    generatePaginationLink(pageNum) {
      const params = _.omitBy(this.currentFilters, _.isNil);
      params.page = pageNum || 1;

      return {
        path: '/accounting/debts/items',
        query: params,
      };
    },

    // Table methods
    isFirstPaymentRow(payments, currentItem) {
      return _.findIndex(payments, ['id', currentItem.id]) === 0;
    },

    calculateTotal(field) {
      const sum = _.sumBy(this.tableData.dataset, (bill) => bill[field] || 0);
      return convertPrice(sum);
    },

    // Action methods
    editModalPayment(bill) {
      this.selectedBill = { billNumber: bill.billNumber };
      this.modalMode = MODAL_MODE;
      this.$bvModal.show('md-debt');
    },

    payByCash(bill, item) {
      const route = this.generatePaymentRoute(bill, item, 'cash');
      this.$router.push(route);
    },

    getBankPaymentRoute(bill, item) {
      return this.generatePaymentRoute(bill, item, 'bank');
    },

    generatePaymentRoute(bill, item, mode) {
      const transactionType =
        mode === 'cash' ? TRANSACTION_TYPE.CashIn : TRANSACTION_TYPE.BankIn;

      return {
        name: 'transaction',
        params: {
          mainModelProp: {
            contactType: CONTACT_TYPE.Installment,
            reconciliationDocType: TRANSACTION_RECONCILIATION_DOC_TYPE.BILL,
            reconciliationDocId: bill.billNumber,
            type: transactionType,
            contactId: item.paymentRefId,
            contactName: item.paymentName,
            amount: item.paymentAmount,
            note: this.generatePaymentNote(bill, item),
          },
          mode,
          action: 'add',
          id: 'new',
        },
      };
    },

    generatePaymentNote(bill, item) {
      return [
        'Nhận thanh toán từ dịch vụ trả góp',
        `Mã HĐ: ${bill.billNumber}`,
        `Dịch vụ: ${item.paymentName}`,
        `Mã hợp đồng: ${item.paymentCode || ''}`,
      ].join('\n');
    },

    showModalExcel() {
      this.modalMode = MODAL_MODE;
      this.$bvModal.show('modal-debt-excel');
    },

    // Utility methods
    convertPrice,
    formatDate,

    isShow(permissions) {
      return checkPermissions(permissions);
    },
  },
};
</script>

<style lang="scss">
.debt-items {
  .icon:hover {
    background-color: #90c6fc;
  }

  .sttClass {
    width: 20px;
  }

  input {
    border: 1px solid #ced4da;
  }

  .date-style {
    display: flex;
    align-items: center;
  }

  .page-item.disabled {
    cursor: not-allowed;
    &.bv-d-xs-down-none {
      .page-link {
        margin: 0.35rem 0.25rem;
        text-align: center;
      }
    }
  }
}

.table th,
.table td {
  vertical-align: middle;
}
</style>
